import { SchemaProps } from 'libs/contentful/props';

const Schema = ({ jsonLd }: SchemaProps) => {
  return (
    jsonLd && (
      <script type="application/ld+json" data-testid="seoMetadataSchema">
        {JSON.stringify(jsonLd)}
      </script>
    )
  );
};

export default Schema;
